var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-event-icon"},[(_vm.showStateIndicator)?_c('element-state',{staticClass:"state-indicator",attrs:{"state":_vm.event.state,"show-tooltip":"","no-background-color":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }